<ng-container *transloco="let t">
  <div class="stepper__container">
    @if (currentStep >= 1 && currentStep <= 4) {
      <ul id="progressbar" class="steper">
        <li class="stepper__step" [ngClass]="{ active: currentStep === 1 }">
          <i class="stepper__step-icon ci-id_card"></i>
          <p class="tag" [ngClass]="{ bold: currentStep === 1 }">{{ t('stepper.information') }}</p>
        </li>
        <li class="stepper__step" [ngClass]="{ active: currentStep === 2 }">
          <i class="stepper__step-icon ci-building"></i>
          <p class="tag" [ngClass]="{ bold: currentStep === 2 }">{{ t('stepper.establishment') }}</p>
        </li>
        <li class="stepper__step" [ngClass]="{ active: currentStep === 3 }">
          <i class="stepper__step-icon ci-user_square"></i>
          <p class="tag" [ngClass]="{ bold: currentStep === 3 }">{{ t('stepper.account') }}</p>
        </li>
        <li class="stepper__step" [ngClass]="{ active: currentStep === 4 }">
          <i class="stepper__step-icon ci-credit_card"></i>
          <p class="tag" [ngClass]="{ bold: currentStep === 4 }">{{ t('stepper.payment') }}</p>
        </li>
      </ul>
    }
    <span class="line-mobile"></span>
  </div>
</ng-container>
